export default {
  data: () => ({
    translations: {
      allRedemptions: {
        el: 'Όλες οι Εξαργυρώσεις',
        en: 'All Redemptions',
        it: 'Tutti i Riscatti',
      },
      statusName: {
        el: 'Κατάσταση',
        en: 'Status',
        it: 'Stato',
      },
      mobile: {
        el: 'Κινητό Πελάτη',
        en: 'User Mobile',
        it: 'Utente Mobile',
      },
      supplierName: {
        el: 'Προμηθευτής',
        en: 'Supplier Name',
        it: 'Fornitore',
      },
      giftTitle: {
        el: 'Όνομα Δώρου',
        en: 'Gift Title',
        it: 'Nome del regalo',
      },
      giftDescription: {
        el: 'Περιγραφή Δώρου',
        en: 'Gift Description',
        it: 'Descrizione del regalo',
      },
      orderCode: {
        el: 'Κωδικός παραγγελίας',
        en: 'Order Code',
        it: 'Order Code',
      },
      date: {
        el: 'Ημερομηνία',
        en: 'Date',
        it: 'Date',
      },
      voucherName: {
        el: 'Όνομα Δωροεπιταγής',
        en: 'Voucher Name',
        it: 'Nome del Buono',
      },
      redemptionDate: {
        el: 'Ημερομηνία',
        en: 'Redemption Date',
        it: 'Date',
      },
      voucherMobile: {
        el: 'Κινητό',
        en: 'Mobile',
        it: 'Cellulare',
      },
      redemptionStore: {
        el: 'Κατάστημα Εξαργύρωσης',
        en: 'Redemption Store',
        it: 'Negozio di Riscatto',
      },
      redemptionStoreCode: {
        el: 'Κωδικός Καταστήματος ',
        en: 'Store Code',
        it: 'Codice Negozio',
      },
      actions: {
        el: 'Ενέργειες',
        en: 'Actions',
        it: 'Azioni',
      },
      cancel: {
        el: 'X',
        en: 'X',
        it: 'X',
      },
      supplierInvoice: {
        el: 'Δελτίο Αποστολής',
        en: 'Delivery Note',
        it: 'Nota di invio',
      },
      paginationText: {
        el: 'από',
        en: 'of',
        it: 'di',
      },
      status: {
        el: 'Κατάσταση',
        en: 'Status',
        it: 'Statο',
      },
      supplier: {
        el: 'Προμηθευτής',
        en: 'Supplier',
        it: 'Fornitore',
      },
      noData: {
        el: 'Δεν υπάρχουν δεδομένα',
        en: 'No data available',
        it: 'Nessun dato disponibile',
      },
      voucherCode: {
        el: 'Κωδικός',
        en: 'Voucher Code',
        it: 'Code',
      },
      couponClaimDate: {
        el: 'Ημερομηνία Απόκτησης',
        en: 'Claim Date',
        it: 'Claim Date',
      },
      couponIsExpired: {
        el: 'Έληξε',
        en: 'Expired',
        it: 'Scaduto',
      },
      couponExpirationDate: {
        el: 'Ημερομηνία λήξης',
        en: 'Expiration Date',
        it: 'Data di scadenza',
      },
      cost: {
        el: 'Αξία',
        en: 'Value',
        it: 'Costo',
      },
      decrease_cashback: {
        el: 'Κόστος Cashback',
        en: 'Decrease Cashback',
        it: 'Decrease Cashback',
      },
      decrease_points: {
        el: 'Κόστος Πόντων',
        en: 'Decrease Points',
        it: 'Decrease Points',
      },
      cancelRedemption: {
        el: 'Επιβεβαίωση ακύρωσης κουπονιού / δώρου',
        en: 'Confirmation of voucher/gift cancellation',
        it: 'Conferma della cancellazione del coupon/regalo',
      },
      cancelRedemptionText: {
        el: 'Σίγουρα θέλετε να ακυρώσετε το συγκεκριμένο δώρο;',
        en: 'Are you sure you want to cancel this particular gift?',
        it: 'Sei sicuro di voler cancellare questo particolare regalo?',
      },
      submit: {
        el: 'Υποβολή',
        en: 'Submit',
        it: 'Invia',
      },
      dialogCancel: {
        el: 'Ακύρωση',
        en: 'Cancel',
        it: 'Cancella',
      },
    },
  }),
};
